import {Link, useSearchParams} from 'react-router-dom';
import {useForm} from 'react-hook-form';
import {FormTextField} from '../../ui/forms/input-field/text-field/text-field';
import {Button} from '../../ui/buttons/button';
import {Form} from '../../ui/forms/form';
import {LinkStyle} from '../../ui/buttons/external-link';
import {AuthLayout} from './auth-layout/auth-layout';
import {
  SendPasswordResetEmailPayload,
  useSendPasswordResetEmail,
} from '../requests/send-reset-password-email';
import {Trans} from '../../i18n/trans';
import {StaticPageTitle} from '../../seo/static-page-title';
import {useSettings} from '../../core/settings/use-settings';

export function ForgotPasswordPage() {
  const {registration} = useSettings();

  const [searchParams] = useSearchParams();
  const searchParamsEmail = searchParams.get('email') || undefined;

  const form = useForm<SendPasswordResetEmailPayload>({
    defaultValues: {email: searchParamsEmail},
  });
  const sendEmail = useSendPasswordResetEmail(form);
  const lng = (e: 'en' | 'tr') => {
    console.log('e',e);
    //  if (e === 'tr') {
    //    setEmailText('E-posta');
    //    setPasswordText('Şifre');
    //  } else {
    //    setEmailText('Email');
    //    setPasswordText('Password');
    //  }
   };
  const message = !registration.disable && (
    <Trans
      values={{
        a: parts => (
          <Link className={LinkStyle} to="/register">
            {parts}
          </Link>
        ),
      }}
      message="Don't have an account? <a>Sign up.</a>"
    />
  );

  return (
    <AuthLayout message={message} updateLang={lng}>
      <StaticPageTitle>
        <Trans message="Forgot Password" />
      </StaticPageTitle>
      <div className="my-auto flex flex-col justify-center px-4 pt-8  md:justify-start lg:w-[28rem]">
        <p className="text-center text-[22px] text-primary font-bold md:text-left md:leading-tight"><Trans message="Forgot Password" /></p>
        <p className="mt-2 text-center text-[16px] md:text-left">
          <Trans message="Already have an account?" />
          <Link to="/login" className="whitespace-nowrap font-semibold text-orange-500"> <Trans  message="Signin"/></Link>
        </p>
        <p className="mt-2 text-center text-[16px] md:text-left">
        
        <Trans message="Enter your email address below and we will send you a link to reset or create your password." />
         
        </p>
        
      
      <Form
        form={form}
        className="flex flex-col pt-3 md:pt-8"
        onSubmit={payload => {
          sendEmail.mutate(payload);
        }}
      >
        
        <FormTextField
          disabled={!!searchParamsEmail}
          className="w-full rounded-md flex-shrink appearance-none border-gray-300 bg-white py-2 px-4 text-base text-gray-700 placeholder-gray-400"
          name="email"
          type="email"
          autoComplete="off"
          autoCorrect="off"
          spellCheck="false"
          placeholder="Email"
          required
          labelSuffix={
            <Link className={LinkStyle} to="/forgot-password" tabIndex={-1}>
              <Trans message="Forgot your password?" />
            </Link>
          }
        />
        <Button
          className="mt-6 w-full rounded-lg bg-primary px-4 py-2 text-center text-base font-semibold text-white shadow-md outline-none ring-blue-500 ring-offset-2 transition hover:bg-blue-700 focus:ring-2 "
          type="submit"
          variant="flat"
          color="primary"
          size="md"
          disabled={sendEmail.isLoading}
        >
          <Trans message="Continue" />
        </Button>
      </Form>
      </div>
    </AuthLayout>
  );
}
